import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    // writingMode: "horizontal-rl", // Vertical writing mode
    // textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",

    // transform: "rotate(180deg)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const LifeTimeDonarsTableData = (props: any) => {
 
  return (
    <>
      <StyledTableContainer sx={{ width: "100%",marginTop:"16px" }}>
        <StyledTable aria-label="customized table">
          <TableHead>
            <TableRow sx={{whiteSpace:"nowrap"}}>
              <>
                {Object.values(props.tableHeaders).map((header: any) => {
                  const headerCol = props.tableHeaders[header];
                  if (
                    headerCol !== "middlename" &&
                    headerCol !== "firstname" &&
                    headerCol !== "lastname" &&
                    headerCol !== "familymemberinfo" &&
                    headerCol !== "sno" &&
                    headerCol !== "city" &&
                    headerCol !== "state" &&
                    headerCol !== "country" &&
                    headerCol !== "zipcode" &&
                    headerCol !== "phonework" &&
                    headerCol !== "poojadate" &&

                    headerCol !== "dateofpoojabooking"
                  ) {
                    return (
                      <StyledTableCell align="left" key={header}>
                        <div
                          style={{
                            textTransform: "capitalize",
                            alignItems: "start",
                          }}
                        >
                          {header === "username"
                            ? "Devotee Name (Sign-in Name)"
                            : header === "phoneresidence"
                            ? "Phone"
                            : header}
                        </div>
                      </StyledTableCell>
                    );
                  }
                })}
              </>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.ReportData.map((item: any, index: any) => (
              <React.Fragment  key={index}>
                <StyledTableRow>
                  {Object.keys(props.tableHeaders).map((column) => (
                    <>
                      {column !== "firstname" &&
                      column !== "middlename" &&
                      column !== "lastname" &&
                      column !== "familymemberinfo" &&
                      column !== "sno" &&
                      column !== "city" &&
                      column !== "state" &&
                      column !== "country" &&
                      column !== "zipcode" &&
                      column !== "dateofpoojabooking" &&
                      column !== "poojadate" &&
                      column !== "phonework" ? (
                        <StyledTableCell key={column}>
                          {column === "address" ? (
                            <div>
                              {item.address}
                              <br /> {item.city} {item.state} <br />{" "}
                              {item.zipcode}
                            </div>
                          ) : Array.isArray(item[column]) ? (
                            item[column].map((obj: any, objIndex: number) => (
                              <div key={objIndex}>
                                {obj.firstname} {obj.middlename} {obj.lastname}{" "}
                                ({obj.relation})
                              </div>
                            ))
                          ) : (
                            <div>
                              {column === "username" ? (
                                <div>
                                  {item.firstname} {item.middlename}{" "}
                                  {item.lastname} ({item.username})
                                  <br />
                                  <ul
                                    style={{
                                      listStyleType: "none",
                                      margin: "0",
                                      padding: "0 0 0 15px",
                                    }}
                                  >
                                    {Object.keys(item).map(
                                      (key) =>
                                        key !== "username" &&
                                        key === "familymemberinfo" &&
                                        (Array.isArray(item[key]) ? (
                                          item[key].map(
                                            (obj: any, objIndex: number) => (
                                              <li key={`${key}-${objIndex}`}>
                                                {obj.firstname} {obj.middlename}{" "}
                                                {obj.lastname} ({obj.relation})
                                              </li>
                                            )
                                          )
                                        ) : (
                                          <li key={key}>{item[key]}</li>
                                        ))
                                    )}
                                  </ul>
                                </div>
                              ) : (
                                <div>
                                  {column === "nakshtram" ? (
                                    <div>
                                      {item.nakshtram ? item.nakshtram : " - "}
                                      <br />
                                      <ul
                                        style={{
                                          listStyleType: "none",
                                          padding: "0 0 0 15px",
                                          margin: "0",
                                        }}
                                      >
                                        {Object.keys(item).map(
                                          (key) =>
                                            key !== "nakshtram" &&
                                            key === "familymemberinfo" &&
                                            (Array.isArray(item[key]) ? (
                                              item[key].map(
                                                (
                                                  obj: any,
                                                  objIndex: number
                                                ) => (
                                                  <li
                                                    key={`${key}-${objIndex}`}
                                                  >
                                                    {obj.nakshtram
                                                      ? obj.nakshtram
                                                      : " - "}
                                                  </li>
                                                )
                                              )
                                            ) : (
                                              <li key={key}>{item[key]}</li>
                                            ))
                                        )}
                                      </ul>
                                    </div>
                                  ) : (
                                    <div>
                                      {column === "gothram" ? (
                                        <div>
                                          {item.gothram ? item.gothram : " - "}
                                          <br />
                                          <ul
                                            style={{
                                              listStyleType: "none",
                                              padding: "0 0 0 15px",
                                              margin: "0",
                                            }}
                                          >
                                            {Object.keys(item).map(
                                              (key) =>
                                                key !== "gothram" &&
                                                key === "familymemberinfo" &&
                                                (Array.isArray(item[key]) ? (
                                                  item[key].map(
                                                    (
                                                      obj: any,
                                                      objIndex: number
                                                    ) => (
                                                      <li
                                                        key={`${key}-${objIndex}`}
                                                      >
                                                        {obj.gothram
                                                          ? obj.gothram
                                                          : " - "}
                                                      </li>
                                                    )
                                                  )
                                                ) : (
                                                  <li key={key}>{item[key]}</li>
                                                ))
                                            )}
                                          </ul>
                                        </div>
                                      ) : // Render phone residence and phone work here
                                      column === "phoneresidence" ? (
                                        <div>
                                          {item.phoneresidence} (Residence)
                                          <br />
                                          {item.phonework} (Work)
                                        </div>
                                      ) : (
                                        item[column]
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </StyledTableCell>
                      ) : null}
                    </>
                  ))}
                </StyledTableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>
    </>
  );
};

export default LifeTimeDonarsTableData;
